import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import Icon, { IconNameT } from '@/components/common/Icon.tsx'
import { SingleLabelGroup as SingleLabelGroupType } from '@/routes/settings/labels/types/label.ts'
import { Flag } from 'lucide-react'

export function createLabelGroupProperty(labelGroup: SingleLabelGroupType) {
  const { labels } = createLabelsProperties(labelGroup)

  const labelGroupProp: PopoverProperty = {
    label: labelGroup?.name ?? '',
    value: labelGroup?.[`@id`] ?? '',
    icon: labels[0]?.icon ?? <Flag className={`size-4`} />,
    children: labels,
    id: labelGroup?.[`@id`] ?? '',
  }

  return labelGroupProp
}

export function createLabelsProperties(
  labelGroup: SingleLabelGroupType | undefined,
  selectAllProperty?: PopoverProperty,
): { labels: PopoverProperty[] } {
  const labels: PopoverProperty[] =
    labelGroup?.labels?.map(label => {
      const prop: PopoverProperty = {
        label: label.name,
        value: label['@id'] as string,
        icon: <Icon icon={label.icon as IconNameT} />,
        parent: labelGroup?.[`@id`] ?? '/labels',
      }
      return prop
    }) ?? []

  if (selectAllProperty) {
    labels.unshift(selectAllProperty)
  }

  return { labels }
}
